export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-iceland-3679f6f03dfc4358e6898e8ebce7d633.jpg";